// extracted by mini-css-extract-plugin
export default {"note":"ChangedEmail_note__C3Wdf"};